import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { IoSearchOutline } from 'react-icons/io5';
import { getOutgoingCallHistory } from '../../../../redux/actions/IVR.action';

// Same UI + same functionality as IncomingCall page (views/master/IVR/Incomming),
// only the data source differs: GET /api/ivr/ctc/outgoing-call
export default function OutgoingCall() {
  const dispatch = useDispatch();
  const ivr = useSelector((state) => state.ivr);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [search, setSearch] = useState('');

  const data = ivr?.getOutgoingCall?.data?.data || [];
  const totalCalls = ivr?.getOutgoingCall?.data?.totalCalls || 0;
  const totalPages = ivr?.getOutgoingCall?.data?.totalPages || 1;

  useEffect(() => {
    dispatch(
      getOutgoingCallHistory({
        page,
        limit: rowsPerPage,
        startDate,
        endDate,
        search,
      }),
    );
  }, [dispatch, page, rowsPerPage, startDate, endDate, search]);

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(1);
  };

  return (
    <div className="mt-[100px]">
      {/* Filters row */}
      <div className="d-flex flex-wrap justify-content-between align-items-start gap-3 mb-3">
        <div className="d-flex flex-wrap gap-3">
          <div>
            <label className="text-sm d-block mb-1">Start Date</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value);
                setPage(1);
              }}
              className="outline-none"
              style={{
                border: '1px solid #dee2e6',
                borderRadius: '8px',
                padding: '8px 12px',
                background: '#fff',
              }}
            />
          </div>
          <div>
            <label className="text-sm d-block mb-1">End Date</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => {
                setEndDate(e.target.value);
                setPage(1);
              }}
              className="outline-none"
              style={{
                border: '1px solid #dee2e6',
                borderRadius: '8px',
                padding: '8px 12px',
                background: '#fff',
              }}
            />
          </div>
        </div>
        <div className="d-flex flex-column align-items-end gap-3">
          <div
            className="bg-white d-flex align-items-center gap-2"
            style={{
              border: '1px solid #dee2e6',
              borderRadius: '999px',
              padding: '10px 20px',
              minWidth: '260px',
            }}
          >
            <IoSearchOutline />
            <input
              type="text"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              className="w-100 outline-none border-0"
              placeholder="Search here..."
            />
          </div>
          <div className="d-flex align-items-center gap-3">
            <select
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              className="border rounded-md focus:outline-none"
              style={{ padding: '6px 10px' }}
            >
              <option value={10}>10 rows</option>
              <option value={30}>30 rows</option>
              <option value={50}>50 rows</option>
              <option value={100}>100 rows</option>
            </select>
            <span
              className="rounded-pill px-3 py-2"
              style={{ background: '#f1f3f6', fontWeight: 500 }}
            >
              Total Records: <strong>{totalCalls}</strong>
            </span>
          </div>
        </div>
      </div>

      <div
        className="table-responsive"
        style={{ background: '#fff', borderRadius: '10px' }}
      >
        <table className="table table-striped align-middle mb-0">
          <thead>
            <tr>
              <th>NO</th>
              <th>DATE</th>
              <th>TIME</th>
              <th>CALLER</th>
              <th>RECEIVER</th>
              <th>RECORDING URL</th>
              <th>CALL DURATION</th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((res, idx) => (
                <tr key={res._id}>
                  <td>{(page - 1) * rowsPerPage + idx + 1}</td>
                  <td>
                    {res.createdAt
                      ? moment(res.createdAt).format('DD/MM/YYYY')
                      : '-'}
                  </td>
                  <td>
                    {res.createdAt
                      ? moment(res.createdAt).format('hh:mm:ss A')
                      : '-'}
                  </td>
                  <td>
                    {res.caller?.name || '-'} | {res.callerNumber}
                  </td>
                  <td>
                    {res.reciver?.firstName || '-'} | {res.reciverNumber}
                  </td>
                  <td>
                    {res.recordingUrl ? (
                      <a
                        href={res.recordingUrl}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          color: '#2563eb',
                          textDecoration: 'underline',
                          fontWeight: 500,
                        }}
                      >
                        View Recording
                      </a>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>{res.callDuration || '-'}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-4">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="d-flex justify-content-center align-items-center gap-2 mt-3">
          <button
            className="btn btn-sm btn-outline-secondary"
            disabled={page <= 1}
            onClick={() => setPage((p) => Math.max(1, p - 1))}
          >
            Prev
          </button>
          <span>
            Page {page} of {totalPages}
          </span>
          <button
            className="btn btn-sm btn-outline-secondary"
            disabled={page >= totalPages}
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}
